import MainLayout from '../layouts/main';
import ReportContainer from './container';

function ReportPage() {
  return (
    <MainLayout>
      <ReportContainer/>
    </MainLayout>
  );
}

export default ReportPage;
